// // // // import React, { useState, useEffect } from 'react';
// // // // import { db } from '../firebase'; // Import your Firebase setup
// // // // import { collection, getDocs } from 'firebase/firestore';
// // // // import { Bar, Pie } from 'react-chartjs-2'; // Import Bar and Pie charts from react-chartjs-2
// // // // import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import Data Labels Plugin
// // // // import 'chart.js/auto'; // Required for chart.js to work
// // // // import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Grid, Card, CardContent, Button } from '@mui/material'; // Import Material-UI components
// // // // import * as XLSX from 'xlsx'; // Import xlsx for Excel export
// // // // import { saveAs } from 'file-saver'; // Import file-saver to save the Excel file

// // // // const OrdersDashboard = () => {
// // // //   const [orders, setOrders] = useState([]);
// // // //   const [month, setMonth] = useState(''); // Selected month filter
// // // //   const [year, setYear] = useState(''); // Selected year filter
// // // //   const [productCounts, setProductCounts] = useState({});
// // // //   const [orderCounts, setOrderCounts] = useState(0);
// // // //   const [userOrderCounts, setUserOrderCounts] = useState({});

// // // //   useEffect(() => {
// // // //     // Fetch all orders from Firestore
// // // //     const fetchOrders = async () => {
// // // //       const ordersCollection = collection(db, 'orders');
// // // //       const ordersSnapshot = await getDocs(ordersCollection);
// // // //       const ordersList = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
// // // //       setOrders(ordersList);
// // // //     };

// // // //     fetchOrders();
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     if (orders.length > 0) {
// // // //       filterOrders();
// // // //     }
// // // //   }, [month, year, orders]); // Re-run when filters or orders change

// // // //   const filterOrders = () => {
// // // //     const filtered = orders.filter((order) => {
// // // //       const orderDate = new Date(order.orderDate.seconds * 1000);
// // // //       const orderMonth = orderDate.getMonth() + 1; // getMonth() is zero-based
// // // //       const orderYear = orderDate.getFullYear();

// // // //       return (
// // // //         (month === '' || orderMonth === parseInt(month)) &&
// // // //         (year === '' || orderYear === parseInt(year))
// // // //       );
// // // //     });

// // // //     calculateProductCounts(filtered);
// // // //     calculateUserOrderCounts(filtered);
// // // //     setOrderCounts(filtered.length); // Total number of orders for the selected period
// // // //   };

// // // //   const calculateProductCounts = (orders) => {
// // // //     const productCounts = {};

// // // //     orders.forEach((order) => {
// // // //       order.items.forEach((item) => {
// // // //         // Ensure product name is treated as a unique key
// // // //         const productName = item.name;

// // // //         // Initialize or increment the quantity for the product
// // // //         if (productCounts[productName]) {
// // // //           productCounts[productName] += Number(item.quantity); // Convert to number before adding
// // // //         } else {
// // // //           productCounts[productName] = Number(item.quantity); // Initialize with number value
// // // //         }
// // // //       });
// // // //     });

// // // //     setProductCounts(productCounts);
// // // //   };

// // // //   const calculateUserOrderCounts = (orders) => {
// // // //     const userCounts = {};

// // // //     orders.forEach((order) => {
// // // //       const username = order.user;
// // // //       if (userCounts[username]) {
// // // //         userCounts[username] += 1;
// // // //       } else {
// // // //         userCounts[username] = 1;
// // // //       }
// // // //     });

// // // //     setUserOrderCounts(userCounts);
// // // //   };

// // // //   // Generate dynamic colors for products
// // // //   const generateColors = (num) => {
// // // //     const colors = [];
// // // //     for (let i = 0; i < num; i++) {
// // // //       colors.push(`hsl(${(i * 360) / num}, 70%, 50%)`); // Use HSL to generate distinct colors
// // // //     }
// // // //     return colors;
// // // //   };

// // // //   const productLabels = Object.keys(productCounts);
// // // //   const productData = Object.values(productCounts);
// // // //   const productColors = generateColors(productLabels.length);

// // // //   // Prepare data for Product Orders Bar Chart
// // // //   const productChartData = {
// // // //     labels: productLabels,
// // // //     datasets: [
// // // //       {
// // // //         label: 'Number of Products Ordered',
// // // //         data: productData,
// // // //         backgroundColor: productColors,
// // // //         borderColor: productColors.map((color) => color.replace('70%', '60%')),
// // // //         borderWidth: 1,
// // // //       },
// // // //     ],
// // // //   };

// // // //   // Prepare data for User Orders Pie Chart
// // // //   const userOrderLabels = Object.keys(userOrderCounts);
// // // //   const userOrderData = Object.values(userOrderCounts);
// // // //   const userOrderColors = generateColors(userOrderLabels.length);

// // // //   const userOrderChartData = {
// // // //     labels: userOrderLabels,
// // // //     datasets: [
// // // //       {
// // // //         data: userOrderData,
// // // //         backgroundColor: userOrderColors,
// // // //         borderColor: userOrderColors.map((color) => color.replace('70%', '60%')),
// // // //         borderWidth: 1,
// // // //       },
// // // //     ],
// // // //   };

// // // //   // Chart Options with Data Labels
// // // //   const chartOptionsWithLabels = {
// // // //     plugins: {
// // // //       datalabels: {
// // // //         color: '#fff',
// // // //         anchor: 'end',
// // // //         align: 'start',
// // // //         formatter: (value) => value,
// // // //       },
// // // //     },
// // // //     responsive: true,
// // // //     maintainAspectRatio: false,
// // // //   };

// // // //   // Export data to Excel
// // // //   const exportToExcel = () => {
// // // //     const data = [
// // // //       {
// // // //         sheetName: 'Product Orders',
// // // //         data: [['Product', 'Quantity Ordered'], ...productLabels.map((label, i) => [label, productData[i]])],
// // // //       },
// // // //       {
// // // //         sheetName: 'User Orders',
// // // //         data: [['User', 'Number of Orders'], ...userOrderLabels.map((label, i) => [label, userOrderData[i]])],
// // // //       },
// // // //     ];

// // // //     const wb = XLSX.utils.book_new();

// // // //     data.forEach((sheet) => {
// // // //       const ws = XLSX.utils.aoa_to_sheet(sheet.data);
// // // //       XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
// // // //     });

// // // //     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
// // // //     saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'OrdersData.xlsx');
// // // //   };

// // // //   return (
// // // //     <Box sx={{ padding: 2, maxWidth: 800, margin: '0 auto' , height:'100%',overflow:'auto' }}>
// // // //       <Typography variant="h4" align="center" gutterBottom>
// // // //       לוח המחוונים להזמנות
// // // //       </Typography>

// // // //       {/* Filter Form */}
// // // //       <Grid container spacing={2} justifyContent="center" alignItems="center">
// // // //         <Grid item xs={12} sm={6}>
// // // //           <FormControl fullWidth>
// // // //             <InputLabel>חודש</InputLabel>
// // // //             <Select value={month} onChange={(e) => setMonth(e.target.value)} label="Month">
// // // //               <MenuItem value="">All</MenuItem>
// // // //               {[...Array(12)].map((_, i) => (
// // // //                 <MenuItem key={i + 1} value={i + 1}>
// // // //                   {i + 1}
// // // //                 </MenuItem>
// // // //               ))}
// // // //             </Select>
// // // //           </FormControl>
// // // //         </Grid>
// // // //         <Grid item xs={12} sm={6}>
// // // //           <FormControl fullWidth>
// // // //             <InputLabel>שנה</InputLabel>
// // // //             <Select value={year} onChange={(e) => setYear(e.target.value)} label="Year">
// // // //               <MenuItem value="">All</MenuItem>
// // // //               {[...new Set(orders.map((order) => new Date(order.orderDate.seconds * 1000).getFullYear()))].map(
// // // //                 (year) => (
// // // //                   <MenuItem key={year} value={year}>
// // // //                     {year}
// // // //                   </MenuItem>
// // // //                 )
// // // //               )}
// // // //             </Select>
// // // //           </FormControl>
// // // //         </Grid>
// // // //       </Grid>

// // // //       {/* Product Orders Bar Chart */}
// // // //       <Card sx={{ marginTop: 4 }}>
// // // //         <CardContent>
// // // //           <Typography variant="h6" align="center" gutterBottom>
// // // //           מספר המוצרים שהוזמנו
// // // //           </Typography>
// // // //           <Box sx={{ width: '100%', height: '300px' }}>
// // // //             <Bar data={productChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// // // //           </Box>
// // // //         </CardContent>
// // // //       </Card>

// // // //       {/* User Orders Pie Chart */}
// // // //       <Card sx={{ marginTop: 4 }}>
// // // //         <CardContent>
// // // //           <Typography variant="h6" align="center" gutterBottom>
// // // //           הזמנות לפי משתמש
// // // //           </Typography>
// // // //           <Box sx={{ width: '100%', height: '300px' }}>
// // // //             <Pie data={userOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// // // //           </Box>
// // // //         </CardContent>
// // // //       </Card>

// // // //       {/* Export to Excel Button */}
// // // //       <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
// // // //         <Button variant="contained" color="primary" onClick={exportToExcel}>
// // // //         ייצוא נתונים לאקסל
// // // //         </Button>
// // // //       </Box>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default OrdersDashboard;
// // // import React, { useState, useEffect } from 'react';
// // // import { db } from '../firebase'; // Import your Firebase setup
// // // import { collection, getDocs } from 'firebase/firestore';
// // // import { Bar, Pie } from 'react-chartjs-2'; // Import Bar and Pie charts from react-chartjs-2
// // // import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import Data Labels Plugin
// // // import 'chart.js/auto'; // Required for chart.js to work
// // // import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Grid, Card, CardContent, Button } from '@mui/material'; // Import Material-UI components
// // // import * as XLSX from 'xlsx'; // Import xlsx for Excel export
// // // import { saveAs } from 'file-saver'; // Import file-saver to save the Excel file

// // // const OrdersDashboard = () => {
// // //   const [orders, setOrders] = useState([]);
// // //   const [month, setMonth] = useState(''); // Selected month filter
// // //   const [year, setYear] = useState(''); // Selected year filter
// // //   const [productCounts, setProductCounts] = useState({});
// // //   const [orderCounts, setOrderCounts] = useState(0);
// // //   const [userOrderCounts, setUserOrderCounts] = useState({});

// // //   useEffect(() => {
// // //     // Fetch all orders from Firestore
// // //     const fetchOrders = async () => {
// // //       const ordersCollection = collection(db, 'orders');
// // //       const ordersSnapshot = await getDocs(ordersCollection);
// // //       const ordersList = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
// // //       setOrders(ordersList);
// // //     };

// // //     fetchOrders();
// // //   }, []);

// // //   const changeBodyBackground = (background) => {
// // //     document.body.style.background = background;
// // //   };


// // //   useEffect(() => {
// // //     changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
// // //     return () => changeBodyBackground(''); // Reset background on unmount
// // //   }, []);


// // //   useEffect(() => {
// // //     if (orders.length > 0) {
// // //       filterOrders();
// // //     }
// // //   }, [month, year, orders]); // Re-run when filters or orders change

// // //   const filterOrders = () => {
// // //     const filtered = orders.filter((order) => {
// // //       const orderDate = new Date(order.orderDate.seconds * 1000);
// // //       const orderMonth = orderDate.getMonth() + 1; // getMonth() is zero-based
// // //       const orderYear = orderDate.getFullYear();

// // //       return (
// // //         (month === '' || orderMonth === parseInt(month)) &&
// // //         (year === '' || orderYear === parseInt(year))
// // //       );
// // //     });

// // //     calculateProductCounts(filtered);
// // //     calculateUserOrderCounts(filtered);
// // //     setOrderCounts(filtered.length); // Total number of orders for the selected period
// // //   };

// // //   const calculateProductCounts = (orders) => {
// // //     const productCounts = {};

// // //     orders.forEach((order) => {
// // //       order.items.forEach((item) => {
// // //         // Ensure product name is treated as a unique key
// // //         const productName = item.name;

// // //         // Initialize or increment the quantity for the product
// // //         if (productCounts[productName]) {
// // //           productCounts[productName] += Number(item.quantity); // Convert to number before adding
// // //         } else {
// // //           productCounts[productName] = Number(item.quantity); // Initialize with number value
// // //         }
// // //       });
// // //     });

// // //     setProductCounts(productCounts);
// // //   };

// // //   const calculateUserOrderCounts = (orders) => {
// // //     const userCounts = {};

// // //     orders.forEach((order) => {
// // //       const username = order.user;
// // //       if (userCounts[username]) {
// // //         userCounts[username] += 1;
// // //       } else {
// // //         userCounts[username] = 1;
// // //       }
// // //     });

// // //     setUserOrderCounts(userCounts);
// // //   };

// // //   // Generate dynamic colors for products
// // //   const generateColors = (num) => {
// // //     const colors = [];
// // //     for (let i = 0; i < num; i++) {
// // //       colors.push(`hsl(${(i * 360) / num}, 70%, 50%)`); // Use HSL to generate distinct colors
// // //     }
// // //     return colors;
// // //   };

// // //   const productLabels = Object.keys(productCounts);
// // //   const productData = Object.values(productCounts);
// // //   const productColors = generateColors(productLabels.length);

// // //   // Prepare data for Product Orders Bar Chart
// // //   const productChartData = {
// // //     labels: productLabels,
// // //     datasets: [
// // //       {
// // //         label: 'Number of Products Ordered',
// // //         data: productData,
// // //         backgroundColor: productColors,
// // //         borderColor: productColors.map((color) => color.replace('70%', '60%')),
// // //         borderWidth: 1,
// // //       },
// // //     ],
// // //   };

// // //   // Prepare data for User Orders Pie Chart
// // //   const userOrderLabels = Object.keys(userOrderCounts);
// // //   const userOrderData = Object.values(userOrderCounts);
// // //   const userOrderColors = generateColors(userOrderLabels.length);

// // //   const userOrderChartData = {
// // //     labels: userOrderLabels,
// // //     datasets: [
// // //       {
// // //         data: userOrderData,
// // //         backgroundColor: userOrderColors,
// // //         borderColor: userOrderColors.map((color) => color.replace('70%', '60%')),
// // //         borderWidth: 1,
// // //       },
// // //     ],
// // //   };

// // //   // Chart Options with Data Labels
// // //   const chartOptionsWithLabels = {
// // //     plugins: {
// // //       datalabels: {
// // //         color: '#fff',
// // //         anchor: 'end',
// // //         align: 'start',
// // //         formatter: (value) => value,
// // //       },
// // //     },
// // //     responsive: true,
// // //     maintainAspectRatio: false,
// // //   };

// // //   // Export data to Excel
// // //   const exportToExcel = () => {
// // //     const data = [
// // //       {
// // //         sheetName: 'Product Orders',
// // //         data: [['Product', 'Quantity Ordered'], ...productLabels.map((label, i) => [label, productData[i]])],
// // //       },
// // //       {
// // //         sheetName: 'User Orders',
// // //         data: [['User', 'Number of Orders'], ...userOrderLabels.map((label, i) => [label, userOrderData[i]])],
// // //       },
// // //     ];

// // //     const wb = XLSX.utils.book_new();

// // //     data.forEach((sheet) => {
// // //       const ws = XLSX.utils.aoa_to_sheet(sheet.data);
// // //       XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
// // //     });

// // //     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
// // //     saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'OrdersData.xlsx');
// // //   };

// // //   return (
// // //     <Box sx={{ padding: 2, maxWidth: 1200, margin: '0 auto', height: '100%', overflow: 'auto' }}>
// // //       <Typography variant="h4" align="center" gutterBottom>
// // //         לוח המחוונים להזמנות
// // //       </Typography>

// // //       {/* Filter Form */}
// // //       <Grid container spacing={2} justifyContent="center" alignItems="center">
// // //         <Grid item xs={12} sm={6}>
// // //           <FormControl fullWidth>
// // //             <InputLabel>חודש</InputLabel>
// // //             <Select value={month} onChange={(e) => setMonth(e.target.value)} label="Month">
// // //               <MenuItem value="">All</MenuItem>
// // //               {[...Array(12)].map((_, i) => (
// // //                 <MenuItem key={i + 1} value={i + 1}>
// // //                   {i + 1}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>
// // //         </Grid>
// // //         <Grid item xs={12} sm={6}>
// // //           <FormControl fullWidth>
// // //             <InputLabel>שנה</InputLabel>
// // //             <Select value={year} onChange={(e) => setYear(e.target.value)} label="Year">
// // //               <MenuItem value="">All</MenuItem>
// // //               {[...new Set(orders.map((order) => new Date(order.orderDate.seconds * 1000).getFullYear()))].map(
// // //                 (year) => (
// // //                   <MenuItem key={year} value={year}>
// // //                     {year}
// // //                   </MenuItem>
// // //                 )
// // //               )}
// // //             </Select>
// // //           </FormControl>
// // //         </Grid>
// // //       </Grid>

// // //       {/* Product Orders Bar Chart and User Orders Pie Chart in a Grid */}
// // //       <Grid container spacing={2} sx={{ marginTop: 4 }}>
// // //         {/* Product Orders Bar Chart */}
// // //         <Grid item xs={12} md={6}>
// // //           <Card sx={{ overflowX: 'auto' }}> {/* Add horizontal scroll for small screens */}
// // //             <CardContent>
// // //               <Typography variant="h6" align="center" gutterBottom>
// // //                 מספר המוצרים שהוזמנו
// // //               </Typography>
// // //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}> {/* Responsive height */}
// // //                 <Bar data={productChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// // //               </Box>
// // //             </CardContent>
// // //           </Card>
// // //         </Grid>

// // //         {/* User Orders Pie Chart */}
// // //         <Grid item xs={12} md={6}>
// // //           <Card sx={{ overflowX: 'auto' }}> {/* Add horizontal scroll for small screens */}
// // //             <CardContent>
// // //               <Typography variant="h6" align="center" gutterBottom>
// // //                 הזמנות לפי משתמש
// // //               </Typography>
// // //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}> {/* Responsive height */}
// // //                 <Pie data={userOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// // //               </Box>
// // //             </CardContent>
// // //           </Card>
// // //         </Grid>
// // //       </Grid>

// // //       {/* Export to Excel Button */}
// // //       <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
// // //         <Button variant="contained" color="primary" onClick={exportToExcel}>
// // //           ייצוא נתונים לאקסל
// // //         </Button>
// // //       </Box>
// // //     </Box>
// // //   );
// // // };

// // // export default OrdersDashboard;



// // import React, { useState, useEffect } from 'react';
// // import { db } from '../firebase';
// // import { collection, getDocs } from 'firebase/firestore';
// // import { Bar, Pie } from 'react-chartjs-2';
// // import ChartDataLabels from 'chartjs-plugin-datalabels';
// // import 'chart.js/auto';
// // import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Grid, Card, CardContent, Button } from '@mui/material';
// // import * as XLSX from 'xlsx';
// // import { saveAs } from 'file-saver';

// // const OrdersDashboard = () => {
// //   const [orders, setOrders] = useState([]);
// //   const [month, setMonth] = useState('');
// //   const [year, setYear] = useState('');
// //   const [productCounts, setProductCounts] = useState({});
// //   const [userOrderCounts, setUserOrderCounts] = useState({});
// //   const [unitOrderCounts, setUnitOrderCounts] = useState({});
// //   const [openOrderCounts, setOpenOrderCounts] = useState({});
// //   const [closedOrderCounts, setClosedOrderCounts] = useState({});

// //   useEffect(() => {
// //     const fetchOrders = async () => {
// //       const ordersCollection = collection(db, 'orders');
// //       const ordersSnapshot = await getDocs(ordersCollection);
// //       const ordersList = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
// //       setOrders(ordersList);
// //     };

// //     fetchOrders();
// //   }, []);

// //   useEffect(() => {
// //     if (orders.length > 0) {
// //       filterOrders();
// //     }
// //   }, [month, year, orders]);

// //   const filterOrders = () => {
// //     const filtered = orders.filter((order) => {
// //       const orderDate = new Date(order.orderDate.seconds * 1000);
// //       const orderMonth = orderDate.getMonth() + 1;
// //       const orderYear = orderDate.getFullYear();

// //       return (
// //         (month === '' || orderMonth === parseInt(month)) &&
// //         (year === '' || orderYear === parseInt(year))
// //       );
// //     });

// //     calculateProductCounts(filtered);
// //     calculateUserOrderCounts(filtered);
// //     calculateUnitOrderCounts(filtered);
// //   };

// //   const calculateProductCounts = (orders) => {
// //     const counts = {};
// //     orders.forEach((order) => {
// //       order.items.forEach((item) => {
// //         const productName = item.name;
// //         counts[productName] = (counts[productName] || 0) + Number(item.quantity);
// //       });
// //     });
// //     setProductCounts(counts);
// //   };

// //   const calculateUserOrderCounts = (orders) => {
// //     const counts = {};
// //     orders.forEach((order) => {
// //       const username = order.user;
// //       counts[username] = (counts[username] || 0) + 1;
// //     });
// //     setUserOrderCounts(counts);
// //   };

// //   const calculateUnitOrderCounts = (orders) => {
// //     const totalCounts = {};
// //     const openCounts = {};
// //     const closedCounts = {};

// //     orders.forEach((order) => {
// //       const unit = order.unit;
// //       totalCounts[unit] = (totalCounts[unit] || 0) + 1;

// //       if (order.status !== 'closed') {
// //         openCounts[unit] = (openCounts[unit] || 0) + 1;
// //       } else if (order.status === 'closed') {
// //         closedCounts[unit] = (closedCounts[unit] || 0) + 1;
// //       }
// //     });

// //     setUnitOrderCounts(totalCounts);
// //     setOpenOrderCounts(openCounts);
// //     setClosedOrderCounts(closedCounts);
// //   };

// //   const generateColors = (num) => {
// //     const colors = [];
// //     for (let i = 0; i < num; i++) {
// //       colors.push(`hsl(${(i * 360) / num}, 70%, 50%)`);
// //     }
// //     return colors;
// //   };

// //   const productLabels = Object.keys(productCounts);
// //   const productData = Object.values(productCounts);
// //   const productColors = generateColors(productLabels.length);

// //   const unitLabels = Object.keys(unitOrderCounts);
// //   const unitData = Object.values(unitOrderCounts);
// //   const unitColors = generateColors(unitLabels.length);

// //   const openOrderLabels = Object.keys(openOrderCounts);
// //   const openOrderData = Object.values(openOrderCounts);
// //   const openOrderColors = generateColors(openOrderLabels.length);

// //   const closedOrderLabels = Object.keys(closedOrderCounts);
// //   const closedOrderData = Object.values(closedOrderCounts);
// //   const closedOrderColors = generateColors(closedOrderLabels.length);

// //   const userOrderLabels = Object.keys(userOrderCounts);
// //   const userOrderData = Object.values(userOrderCounts);
// //   const userOrderColors = generateColors(userOrderLabels.length);

// //   const productChartData = {
// //     labels: productLabels,
// //     datasets: [{ label: 'Products Ordered', data: productData, backgroundColor: productColors }],
// //   };

// //   const unitChartData = {
// //     labels: unitLabels,
// //     datasets: [{ label: 'Orders Per Unit', data: unitData, backgroundColor: unitColors }],
// //   };

// //   const openOrderChartData = {
// //     labels: openOrderLabels,
// //     datasets: [{ label: 'Open Orders Per Unit', data: openOrderData, backgroundColor: openOrderColors }],
// //   };

// //   const closedOrderChartData = {
// //     labels: closedOrderLabels,
// //     datasets: [{ label: 'Closed Orders Per Unit', data: closedOrderData, backgroundColor: closedOrderColors }],
// //   };

// //   const userOrderChartData = {
// //     labels: userOrderLabels,
// //     datasets: [{ data: userOrderData, backgroundColor: userOrderColors }],
// //   };

// //   const chartOptionsWithLabels = {
// //     plugins: {
// //       datalabels: { color: '#fff', anchor: 'end', align: 'start' },
// //     },
// //     responsive: true,
// //     maintainAspectRatio: false,
// //   };

// //   const exportToExcel = () => {
// //     const data = [
// //       {
// //         sheetName: 'Product Orders',
// //         data: [['Product', 'Quantity Ordered'], ...productLabels.map((label, i) => [label, productData[i]])],
// //       },
// //       {
// //         sheetName: 'Unit Orders',
// //         data: [['Unit', 'Total Orders'], ...unitLabels.map((label, i) => [label, unitData[i]])],
// //       },
// //       {
// //         sheetName: 'Open Orders',
// //         data: [['Unit', 'Open Orders'], ...openOrderLabels.map((label, i) => [label, openOrderData[i]])],
// //       },
// //       {
// //         sheetName: 'Closed Orders',
// //         data: [['Unit', 'Closed Orders'], ...closedOrderLabels.map((label, i) => [label, closedOrderData[i]])],
// //       },
// //       {
// //         sheetName: 'User Orders',
// //         data: [['User', 'Number of Orders'], ...userOrderLabels.map((label, i) => [label, userOrderData[i]])],
// //       },
// //     ];

// //     const wb = XLSX.utils.book_new();

// //     data.forEach((sheet) => {
// //       const ws = XLSX.utils.aoa_to_sheet(sheet.data);
// //       XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
// //     });

// //     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
// //     saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'OrdersData.xlsx');
// //   };

// //   return (
// //     <Box sx={{ padding: 2, maxWidth: 1200, margin: '0 auto', height: '100%', overflow: 'auto' }}>
// //       <Typography variant="h4" align="center" gutterBottom>
// //         לוח המחוונים להזמנות
// //       </Typography>

// //       <Grid container spacing={2} justifyContent="center" alignItems="center">
// //         <Grid item xs={12} sm={6}>
// //           <FormControl fullWidth>
// //             <InputLabel>חודש</InputLabel>
// //             <Select value={month} onChange={(e) => setMonth(e.target.value)} label="Month">
// //               <MenuItem value="">All</MenuItem>
// //               {[...Array(12)].map((_, i) => (
// //                 <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //         <Grid item xs={12} sm={6}>
// //           <FormControl fullWidth>
// //             <InputLabel>שנה</InputLabel>
// //             <Select value={year} onChange={(e) => setYear(e.target.value)} label="Year">
// //               <MenuItem value="">All</MenuItem>
// //               {[...new Set(orders.map((order) => new Date(order.orderDate.seconds * 1000).getFullYear()))].map(
// //                 (year) => (
// //                   <MenuItem key={year} value={year}>{year}</MenuItem>
// //                 )
// //               )}
// //             </Select>
// //           </FormControl>
// //         </Grid>
// //       </Grid>

// //       <Grid container spacing={2} sx={{ marginTop: 4 }}>
// //         <Grid item xs={12} md={6}>
// //           <Card sx={{ overflowX: 'auto' }}>
// //             <CardContent>
// //               <Typography variant="h6" align="center" gutterBottom>מספר המוצרים שהוזמנו</Typography>
// //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}>
// //                 <Bar data={productChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} md={6}>
// //           <Card sx={{ overflowX: 'auto' }}>
// //             <CardContent>
// //               <Typography variant="h6" align="center" gutterBottom>הזמנות לפי משתמש</Typography>
// //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}>
// //                 <Pie data={userOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} md={6}>
// //           <Card sx={{ overflowX: 'auto' }}>
// //             <CardContent>
// //               <Typography variant="h6" align="center" gutterBottom>הזמנות לפי יחידה</Typography>
// //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}>
// //                 <Pie data={unitChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} md={6}>
// //           <Card sx={{ overflowX: 'auto' }}>
// //             <CardContent>
// //               <Typography variant="h6" align="center" gutterBottom>הזמנות פתוחות לפי יחידה</Typography>
// //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}>
// //                 <Pie data={openOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>

// //         <Grid item xs={12} md={6}>
// //           <Card sx={{ overflowX: 'auto' }}>
// //             <CardContent>
// //               <Typography variant="h6" align="center" gutterBottom>הזמנות סגורות לפי יחידה</Typography>
// //               <Box sx={{ width: '100%', height: { xs: '250px', md: '400px' } }}>
// //                 <Pie data={closedOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
// //               </Box>
// //             </CardContent>
// //           </Card>
// //         </Grid>
// //       </Grid>

// //       <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
// //         <Button variant="contained" color="primary" onClick={exportToExcel}>ייצוא נתונים לאקסל</Button>
// //       </Box>
// //     </Box>
// //   );
// // };

// // export default OrdersDashboard;


// import React, { useState, useEffect } from 'react';
// import { db } from '../firebase';
// import { collection, getDocs } from 'firebase/firestore';
// import { Bar, Pie } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import 'chart.js/auto';
// import { Box, Typography, FormControl, InputLabel, Select, MenuItem, Grid, Card, CardContent, Button } from '@mui/material';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';

// const OrdersDashboard = () => {
//   const [orders, setOrders] = useState([]);
//   const [month, setMonth] = useState('');
//   const [year, setYear] = useState('');
//   const [productCounts, setProductCounts] = useState({});
//   const [userOrderCounts, setUserOrderCounts] = useState({});
//   const [unitOrderCounts, setUnitOrderCounts] = useState({});
//   const [openOrderCounts, setOpenOrderCounts] = useState({});
//   const [closedOrderCounts, setClosedOrderCounts] = useState({});
//   const [unitRatings, setUnitRatings] = useState({});

//   const [visibleChart, setVisibleChart] = useState(''); // Track the selected chart

//   useEffect(() => {
//     const fetchOrders = async () => {
//       const ordersCollection = collection(db, 'orders');
//       const ordersSnapshot = await getDocs(ordersCollection);
//       const ordersList = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//       setOrders(ordersList);
//     };

//     fetchOrders();
//   }, []);

//   useEffect(() => {
//     if (orders.length > 0) {
//       filterOrders();
//     }
//   }, [month, year, orders]);

//   const filterOrders = () => {
//     const filtered = orders.filter((order) => {
//       const orderDate = new Date(order.orderDate.seconds * 1000);
//       const orderMonth = orderDate.getMonth() + 1;
//       const orderYear = orderDate.getFullYear();

//       return (
//         (month === '' || orderMonth === parseInt(month)) &&
//         (year === '' || orderYear === parseInt(year))
//       );
//     });

//     calculateProductCounts(filtered);
//     calculateUserOrderCounts(filtered);
//     calculateUnitOrderCounts(filtered);
//     calculateUnitRatings(filtered);
//   };

//   const calculateProductCounts = (orders) => {
//     const counts = {};
//     orders.forEach((order) => {
//       order.items.forEach((item) => {
//         const productName = item.name;
//         counts[productName] = (counts[productName] || 0) + Number(item.quantity);
//       });
//     });
//     setProductCounts(counts);
//   };

//   const calculateUserOrderCounts = (orders) => {
//     const counts = {};
//     orders.forEach((order) => {
//       const username = order.user;
//       counts[username] = (counts[username] || 0) + 1;
//     });
//     setUserOrderCounts(counts);
//   };

//   const calculateUnitOrderCounts = (orders) => {
//     const totalCounts = {};
//     const openCounts = {};
//     const closedCounts = {};
    
//     orders.forEach((order) => {
//       const unit = order.unit;
//       totalCounts[unit] = (totalCounts[unit] || 0) + 1;

//       if (order.status !== 'closed') {
//         openCounts[unit] = (openCounts[unit] || 0) + 1;
//       } else if (order.status === 'closed') {
//         closedCounts[unit] = (closedCounts[unit] || 0) + 1;
//       }
//     });

//     setUnitOrderCounts(totalCounts);
//     setOpenOrderCounts(openCounts);
//     setClosedOrderCounts(closedCounts);
//   };

//   const calculateUnitRatings = (orders) => {
//     const ratingSums = {};
//     const ratingCounts = {};

//     orders.forEach((order) => {
//       const unit = order.unit;
//       const rating = order.rating;
      
//       if (rating !== undefined) {
//         ratingSums[unit] = (ratingSums[unit] || 0) + rating;
//         ratingCounts[unit] = (ratingCounts[unit] || 0) + 1;
//       }
//     });

//     const averageRatings = {};
//     for (const unit in ratingSums) {
//       averageRatings[unit] = ratingSums[unit] / ratingCounts[unit];
//     }

//     setUnitRatings(averageRatings);
//   };

//   const generateColors = (num) => {
//     const colors = [];
//     for (let i = 0; i < num; i++) {
//       colors.push(`hsl(${(i * 360) / num}, 70%, 50%)`);
//     }
//     return colors;
//   };

//   // Data for each chart
//   const productChartData = {
//     labels: Object.keys(productCounts),
//     datasets: [{ label: 'Products Ordered', data: Object.values(productCounts), backgroundColor: generateColors(Object.keys(productCounts).length) }],
//   };

//   const unitChartData = {
//     labels: Object.keys(unitOrderCounts),
//     datasets: [{ label: 'Orders Per Unit', data: Object.values(unitOrderCounts), backgroundColor: generateColors(Object.keys(unitOrderCounts).length) }],
//   };

//   const openOrderChartData = {
//     labels: Object.keys(openOrderCounts),
//     datasets: [{ label: 'Open Orders Per Unit', data: Object.values(openOrderCounts), backgroundColor: generateColors(Object.keys(openOrderCounts).length) }],
//   };

//   const closedOrderChartData = {
//     labels: Object.keys(closedOrderCounts),
//     datasets: [{ label: 'Closed Orders Per Unit', data: Object.values(closedOrderCounts), backgroundColor: generateColors(Object.keys(closedOrderCounts).length) }],
//   };

//   const userOrderChartData = {
//     labels: Object.keys(userOrderCounts),
//     datasets: [{ label: 'Orders by User', data: Object.values(userOrderCounts), backgroundColor: generateColors(Object.keys(userOrderCounts).length) }],
//   };

//   const unitRatingChartData = {
//     labels: Object.keys(unitRatings),
//     datasets: [{ label: 'Average User Experience Rating by Unit', data: Object.values(unitRatings), backgroundColor: generateColors(Object.keys(unitRatings).length) }],
//   };

//   const chartOptionsWithLabels = {
//     plugins: {
//       datalabels: { color: '#fff', anchor: 'end', align: 'start' },
//     },
//     responsive: true,
//     maintainAspectRatio: false,
//   };

//   const exportToExcel = () => {
//     const data = [
//       { sheetName: 'Product Orders', data: [['Product', 'Quantity Ordered'], ...Object.keys(productCounts).map((label, i) => [label, Object.values(productCounts)[i]])] },
//       { sheetName: 'Unit Orders', data: [['Unit', 'Total Orders'], ...Object.keys(unitOrderCounts).map((label, i) => [label, Object.values(unitOrderCounts)[i]])] },
//       { sheetName: 'Open Orders', data: [['Unit', 'Open Orders'], ...Object.keys(openOrderCounts).map((label, i) => [label, Object.values(openOrderCounts)[i]])] },
//       { sheetName: 'Closed Orders', data: [['Unit', 'Closed Orders'], ...Object.keys(closedOrderCounts).map((label, i) => [label, Object.values(closedOrderCounts)[i]])] },
//       { sheetName: 'User Orders', data: [['User', 'Number of Orders'], ...Object.keys(userOrderCounts).map((label, i) => [label, Object.values(userOrderCounts)[i]])] },
//     ];

//     const wb = XLSX.utils.book_new();
//     data.forEach((sheet) => {
//       const ws = XLSX.utils.aoa_to_sheet(sheet.data);
//       XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
//     });

//     const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//     saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'OrdersData.xlsx');
//   };

//   return (
//     <Box sx={{ padding: 2, maxWidth: 1200, margin: '0 auto', height: '100%', overflow: 'auto' }}>
//       <Typography variant="h4" align="center" gutterBottom>
//         לוח המחוונים להזמנות
//       </Typography>

//       <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, marginBottom: 3 }}>
//         <Button variant="contained" onClick={() => setVisibleChart('productOrders')}>מוצרים שהוזמנו</Button>
//         <Button variant="contained" onClick={() => setVisibleChart('userOrders')}>הזמנות לפי משתמש</Button>
//         <Button variant="contained" onClick={() => setVisibleChart('unitOrders')}>הזמנות לפי יחידה</Button>
//         <Button variant="contained" onClick={() => setVisibleChart('openOrders')}>הזמנות פתוחות לפי יחידה</Button>
//         <Button variant="contained" onClick={() => setVisibleChart('closedOrders')}>הזמנות סגורות לפי יחידה</Button>
//         <Button variant="contained" onClick={() => setVisibleChart('unitRatings')}>דירוג חווית משתמש לפי יחידה</Button>
//       </Box>

//       <Grid container spacing={2}>
//         {visibleChart === 'productOrders' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>מספר המוצרים שהוזמנו</Typography>
//                 <Bar data={productChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}

//         {visibleChart === 'userOrders' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>הזמנות לפי משתמש</Typography>
//                 <Pie data={userOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}

//         {visibleChart === 'unitOrders' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>הזמנות לפי יחידה</Typography>
//                 <Pie data={unitChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}

//         {visibleChart === 'openOrders' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>הזמנות פתוחות לפי יחידה</Typography>
//                 <Pie data={openOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}

//         {visibleChart === 'closedOrders' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>הזמנות סגורות לפי יחידה</Typography>
//                 <Pie data={closedOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}

//         {visibleChart === 'unitRatings' && (
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <Typography variant="h6" align="center" gutterBottom>דירוג חווית משתמש לפי יחידה</Typography>
//                 <Bar data={unitRatingChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
//               </CardContent>
//             </Card>
//           </Grid>
//         )}
//       </Grid>

//       <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
//         <Button variant="contained" color="primary" onClick={exportToExcel}>
//           ייצוא נתונים לאקסל
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default OrdersDashboard;

import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import { Bar, Pie } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chart.js/auto';
import { Box, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const OrdersDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [productCounts, setProductCounts] = useState({});
  const [userOrderCounts, setUserOrderCounts] = useState({});
  const [unitOrderCounts, setUnitOrderCounts] = useState({});
  const [openOrderCounts, setOpenOrderCounts] = useState({});
  const [closedOrderCounts, setClosedOrderCounts] = useState({});
  const [unitRatings, setUnitRatings] = useState({});
  const [visibleChart, setVisibleChart] = useState('');

  useEffect(() => {
    const fetchOrders = async () => {
      const ordersCollection = collection(db, 'orders');
      const ordersSnapshot = await getDocs(ordersCollection);
      const ordersList = ordersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setOrders(ordersList);
    };
    fetchOrders();
  }, []);

  useEffect(() => {
    if (orders.length > 0) {
      filterOrders();
    }
  }, [orders]);

  const filterOrders = () => {
    calculateProductCounts(orders);
    calculateUserOrderCounts(orders);
    calculateUnitOrderCounts(orders);
    calculateUnitRatings(orders);
  };

  const calculateProductCounts = (orders) => {
    const counts = {};
    orders.forEach((order) => {
      order.items.forEach((item) => {
        const productName = item.name;
        counts[productName] = (counts[productName] || 0) + Number(item.quantity);
      });
    });
    setProductCounts(counts);
  };

  const calculateUserOrderCounts = (orders) => {
    const counts = {};
    orders.forEach((order) => {
      const username = order.user;
      counts[username] = (counts[username] || 0) + 1;
    });
    setUserOrderCounts(counts);
  };

  const calculateUnitOrderCounts = (orders) => {
    const totalCounts = {};
    const openCounts = {};
    const closedCounts = {};
    
    orders.forEach((order) => {
      const unit = order.unit;
      totalCounts[unit] = (totalCounts[unit] || 0) + 1;
      if (order.status !== 'closed') {
        openCounts[unit] = (openCounts[unit] || 0) + 1;
      } else {
        closedCounts[unit] = (closedCounts[unit] || 0) + 1;
      }
    });
    setUnitOrderCounts(totalCounts);
    setOpenOrderCounts(openCounts);
    setClosedOrderCounts(closedCounts);
  };

  const calculateUnitRatings = (orders) => {
    const ratingSums = {};
    const ratingCounts = {};

    orders.forEach((order) => {
      const unit = order.unit;
      const rating = order.rating;
      
      if (rating !== undefined) {
        ratingSums[unit] = (ratingSums[unit] || 0) + rating;
        ratingCounts[unit] = (ratingCounts[unit] || 0) + 1;
      }
    });

    const averageRatings = {};
    for (const unit in ratingSums) {
      averageRatings[unit] = ratingSums[unit] / ratingCounts[unit];
    }
    setUnitRatings(averageRatings);
  };

  const generateColors = (num) => {
    const colors = [];
    for (let i = 0; i < num; i++) {
      colors.push(`hsl(${(i * 360) / num}, 70%, 50%)`);
    }
    return colors;
  };

  const productChartData = {
    labels: Object.keys(productCounts),
    datasets: [{ label: 'מוצרים שהוזמנו', data: Object.values(productCounts), backgroundColor: generateColors(Object.keys(productCounts).length) }],
  };

  const unitChartData = {
    labels: Object.keys(unitOrderCounts),
    datasets: [{ label: 'הזמנות לפי יחידה', data: Object.values(unitOrderCounts), backgroundColor: generateColors(Object.keys(unitOrderCounts).length) }],
  };

  const openOrderChartData = {
    labels: Object.keys(openOrderCounts),
    datasets: [{ label: 'הזמנות פתוחות לפי יחידה', data: Object.values(openOrderCounts), backgroundColor: generateColors(Object.keys(openOrderCounts).length) }],
  };

  const closedOrderChartData = {
    labels: Object.keys(closedOrderCounts),
    datasets: [{ label: 'הזמנות סגורות לפי יחידה', data: Object.values(closedOrderCounts), backgroundColor: generateColors(Object.keys(closedOrderCounts).length) }],
  };

  const userOrderChartData = {
    labels: Object.keys(userOrderCounts),
    datasets: [{ label: 'הזמנות לפי משתמש', data: Object.values(userOrderCounts), backgroundColor: generateColors(Object.keys(userOrderCounts).length) }],
  };

  const unitRatingChartData = {
    labels: Object.keys(unitRatings),
    datasets: [{ label: 'דירוג חווית משתמש לפי יחידה', data: Object.values(unitRatings), backgroundColor: generateColors(Object.keys(unitRatings).length) }],
  };

  const chartOptionsWithLabels = {
    animation: false,
    plugins: {
      datalabels: { color: '#fff', anchor: 'end', align: 'start' },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  const exportToExcel = () => {
    const data = [
      { sheetName: 'מוצרים שהוזמנו', data: [['מוצר', 'כמות הוזמנה'], ...Object.keys(productCounts).map((label, i) => [label, Object.values(productCounts)[i]])] },
      { sheetName: 'הזמנות לפי יחידה', data: [['יחידה', 'סה"כ הזמנות'], ...Object.keys(unitOrderCounts).map((label, i) => [label, Object.values(unitOrderCounts)[i]])] },
      { sheetName: 'הזמנות פתוחות', data: [['יחידה', 'הזמנות פתוחות'], ...Object.keys(openOrderCounts).map((label, i) => [label, Object.values(openOrderCounts)[i]])] },
      { sheetName: 'הזמנות סגורות', data: [['יחידה', 'הזמנות סגורות'], ...Object.keys(closedOrderCounts).map((label, i) => [label, Object.values(closedOrderCounts)[i]])] },
      { sheetName: 'הזמנות לפי משתמש', data: [['משתמש', 'מספר הזמנות'], ...Object.keys(userOrderCounts).map((label, i) => [label, Object.values(userOrderCounts)[i]])] },
    ];

    const wb = XLSX.utils.book_new();
    data.forEach((sheet) => {
      const ws = XLSX.utils.aoa_to_sheet(sheet.data);
      XLSX.utils.book_append_sheet(wb, ws, sheet.sheetName);
    });

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'נתוני_הזמנות.xlsx');
  };

  return (
    <Box sx={{ padding: 2, maxWidth: 900, margin: '0 auto', overflow: 'auto' }}>
      <Typography variant="h4" align="center" gutterBottom>
        לוח מחוונים להזמנות
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, flexWrap: 'wrap', marginBottom: 3 }}>
        <Button variant="contained" onClick={() => setVisibleChart('productOrders')} size="small">מוצרים שהוזמנו</Button>
        <Button variant="contained" onClick={() => setVisibleChart('userOrders')} size="small">הזמנות לפי משתמש</Button>
        <Button variant="contained" onClick={() => setVisibleChart('unitOrders')} size="small">הזמנות לפי יחידה</Button>
        <Button variant="contained" onClick={() => setVisibleChart('openOrders')} size="small">הזמנות פתוחות לפי יחידה</Button>
        <Button variant="contained" onClick={() => setVisibleChart('closedOrders')} size="small">הזמנות סגורות לפי יחידה</Button>
        <Button variant="contained" onClick={() => setVisibleChart('unitRatings')} size="small">דירוג חווית משתמש לפי יחידה</Button>
      </Box>

      <Grid container spacing={2}>
        {visibleChart === 'productOrders' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>מספר המוצרים שהוזמנו</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Bar data={productChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleChart === 'userOrders' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>הזמנות לפי משתמש</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Pie data={userOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleChart === 'unitOrders' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>הזמנות לפי יחידה</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Pie data={unitChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleChart === 'openOrders' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>הזמנות פתוחות לפי יחידה</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Pie data={openOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleChart === 'closedOrders' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>הזמנות סגורות לפי יחידה</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Pie data={closedOrderChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleChart === 'unitRatings' && (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" align="center" gutterBottom>דירוג חווית משתמש לפי יחידה</Typography>
                <Box sx={{ width: '100%', height: '400px' }}>
                  <Bar data={unitRatingChartData} options={chartOptionsWithLabels} plugins={[ChartDataLabels]} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 4 }}>
        <Button variant="contained" color="primary" onClick={exportToExcel}>
          ייצוא נתונים לאקסל
        </Button>
      </Box>
    </Box>
  );
};

export default OrdersDashboard;
